export default "__VITE_ASSET__Cjb24UwB__"